// extracted by mini-css-extract-plugin
module.exports = {"stageWrap":"AdminSettingsProjectStageContainer_stageWrap__3ETwt","title":"AdminSettingsProjectStageContainer_title__He5pO"};